import LinePlaneDepartureIcon from 'LuxKit/Icons/line/LinePlaneDepartureIcon'
import PromotionLabel from 'LuxKit/Label/PromotionLabel'
import { slugify } from 'lib/string/stringUtils'
import { useIntl } from 'react-intl'

export const DATES_AVAILABLE_2027_CAMPAIGN_TAG_SLUG = '2027_dates_available'

export function hasDatesAvailable2027CampaignTag(tags: Array<string>): boolean {
  return tags.some(tag => slugify(tag) === DATES_AVAILABLE_2027_CAMPAIGN_TAG_SLUG)
}

function DatesAvailable2027CampaignLabel() {
  const intl = useIntl()

  return (
    <PromotionLabel variant="branded" icon={<LinePlaneDepartureIcon />}>
      {intl.formatMessage({
        id: 'zaLT1oDSqpOkEtl1EFuK',
        defaultMessage: '2027 Dates Available',
      })}
    </PromotionLabel>
  )
}

export default DatesAvailable2027CampaignLabel
